import dayjs from "dayjs";
import { Flex } from "antd";
import ReportHeader from "../../component/ReportHeader";

import StylesContainer from "./style";

import { ReactComponent as Hero } from "./image/hero.svg";
import { ReactComponent as Footer } from "./image/footer.svg";

const ReportPageIntroduction = ({
  managerEmail,
  managerName,
  managerPhone,
  personaName,
}) => (
  <StylesContainer id="reportPageIntroduction">
    <Flex className="page-container" vertical>
      <ReportHeader personaName={personaName} />

      <main>
        <Flex style={{ width: 635 }} vertical>
          <h4>Intelligent Design.</h4>
          <h2>Powerful Results.</h2>
          <p>
            BX puts the power back in the advisor’s hands. For too long, the
            investment industry has flooded the market with redundant, mediocre
            solutions distracting from what truly matters, client outcomes. BX
            closes this gap by partnering with advisors to design smarter,
            streamlined portfolios that adapt to today’s dynamic markets and
            tomorrow’s opportunities. Every investment strategy on the BX
            platform is governed by a disciplined process rooted in four
            essential values:
          </p>
          <ul>
            <li>
              <b>Rules-based framework</b> that ensures transparency and
              consistency
            </li>
            <li>
              <b>Targeted precision</b> that aligns each holding with the core
              intent of the investment strategy
            </li>
            <li>
              <b>Proactive rebalancing</b> guided by a factor-driven lens to
              remain responsive to market shifts
            </li>
            <li>
              <b>Relentless focus on risk-adjusted returns because</b> true
              performance is measured by what clients keep, not just what they
              earn
            </li>
          </ul>
          <p>
            These principles are not just part of the process—they are the
            foundation of everything we do.
          </p>
          <p>
            With BX, advisors and their client’s choose from optimized pre-built
            portfolios or create fully customized, white- labeled models all
            powered by the latest technology. This cutting-edge platform
            curates, monitors, and tracks every building block, offering
            open-architecture access to some of the best modern U.S. asset
            managers. Every manager is selected with the understanding that
            behind every investment are real clients, pursuing real goals.{" "}
          </p>
          <p>
            Client outcomes don’t happen by accident. They are
            built—intelligently, intentionally, and relentlessly. At BX, we
            believe advisors and their clients deserve more than choice. They
            deserve <b>innovative choice</b>, crafted to perform, built to
            adapt, and engineered for outcomes.
          </p>
        </Flex>

        <Hero />
      </main>

      <footer>
        <Footer />

        <div>
          <p>Generated by:</p>
          <h5>{managerName}</h5>
          <p>{dayjs().format("MM/DD/YYYY")}</p>
        </div>

        <Flex gap={40}>
          <div>
            <p>421 Granger Place</p>
            <p>Suite 400</p>
            <p>Charlotte, NC 28307</p>
          </div>

          <div>
            <p>{managerEmail}</p>
            {managerPhone && <p>{managerPhone}</p>}
          </div>
        </Flex>
      </footer>
    </Flex>
  </StylesContainer>
);

export default ReportPageIntroduction;
